import Tabs from 'components/Tabs';
import './styles.scss';
import TabPane from 'components/Tabs/TabPane';
import { Button } from 'components/buttons/Button/Button';
import ProductItems from 'components/ProductItems';

const ProductItemsBoxWithTabs = ({ title, data }) => {
    return (
        <div className="box product-box">
            <h3>{title}</h3>
            <Tabs>
                {data.map(tabData => (
                    <TabPane key={tabData.title} title={tabData.title}>
                        <ProductItems data={tabData.data} />
                        <Button type="show-more">SHOW MORE</Button>
                    </TabPane>
                ))}
            </Tabs>
        </div>
    );
};

export default ProductItemsBoxWithTabs;
